import { Grid } from "@mui/material";
import { Book } from "../../app/models/book";
import { useAppSelector } from "../../app/store/configureStore";
import BookCard from "./BookCard";
import BookCardSkeleton from "./BookCardSkeleton";

interface Props {
  books: Book[];
}

const BookList: React.FC<Props> = ({ books }) => {
  const { booksLoaded } = useAppSelector(state => state.catalog);
  return (
    <Grid container spacing={2} className="booklist" sx={{ p: { xs: 0, sm: 0 }}}>
      {
        books.map(book => (
          <Grid size={{ sm: 6, md: 4, lg: 3, xs: 6 }} key={book.id}>
            {!booksLoaded ? (
              <BookCardSkeleton />
            ) : (
              <BookCard book={book} />
            )}
          </Grid>
        ))
      }
    </Grid>
  )
}

export default BookList;
